import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import api, { LOGO_URL } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("ep_token")) nav("/admin");
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("ep_token", r.data.token);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6" data-testid="admin-login">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <img src={LOGO_URL} alt="Elite Pixels" className="h-24 object-contain mx-auto drop-shadow-[0_2px_14px_rgba(212,175,55,0.2)]" />
          <h1 className="font-serif text-3xl mt-6">Admin Portal</h1>
          <p className="text-white/40 text-sm mt-2 tracking-[0.25em] uppercase">Elite Pixels CMS</p>
        </div>
        <form onSubmit={submit} className="space-y-5 bg-[#0a0a0a] border border-white/10 p-8">
          <label className="block">
            <span className="text-[0.65rem] tracking-[0.25em] uppercase text-white/60">Email</span>
            <input type="email" required value={email} onChange={e=>setEmail(e.target.value)} data-testid="login-email"
              className="mt-2 w-full bg-black border border-white/15 px-4 py-3 text-sm focus:border-[#D4AF37] outline-none"/>
          </label>
          <label className="block">
            <span className="text-[0.65rem] tracking-[0.25em] uppercase text-white/60">Password</span>
            <div className="relative mt-2">
              <input type={show ? "text" : "password"} required value={password} onChange={e=>setPassword(e.target.value)} data-testid="login-password"
                autoComplete="current-password"
                className="w-full bg-black border border-white/15 px-4 py-3 pr-12 text-sm focus:border-[#D4AF37] outline-none"/>
              <button type="button" onClick={() => setShow(!show)} data-testid="toggle-password"
                className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-[#D4AF37] transition" aria-label="Toggle password visibility">
                {show ? <EyeOff size={16}/> : <Eye size={16}/>}
              </button>
            </div>
          </label>
          <button type="submit" disabled={busy} className="btn-gold w-full" data-testid="login-submit">
            {busy ? "Signing in..." : "Sign In"}
          </button>
          <a href="/admin/forgot-password" data-testid="forgot-password-link"
            className="block text-center text-xs text-white/50 mt-3 tracking-widest uppercase hover:text-[#D4AF37] transition">
            Forgot password?
          </a>
        </form>
        <a href="/" className="block text-center text-xs text-white/40 mt-6 tracking-widest uppercase hover:text-[#D4AF37]">← Back to site</a>
      </div>
    </div>
  );
}
